import { useQuery } from '@tanstack/react-query';
import { getLeadGenAccess } from '../Api/leadGenApi';

/** `{ enabled }` for Harvest Leads (the shared lead database at /lead-gen). */
export const useHarvestLeadsAccess = (companyId) =>
	useQuery({
		queryKey: ['harvestLeadsAccess', companyId],
		queryFn: async () => (await getLeadGenAccess()).data,
		enabled: !!companyId,
		staleTime: 60 * 1000,
	});
